import { Purchases } from '@revenuecat/purchases-js';

import { ENVIRONMENT } from 'utils/constants';
import {
  REACT_APP_ENV,
  REACT_APP_REVENUECAT_BILLING_PUBLIC_API_KEY,
  REACT_APP_REVENUECAT_BILLING_SANDBOX_API_KEY,
} from 'config';

export const getRevenueCatApiKey = () =>
  REACT_APP_ENV === ENVIRONMENT.DEVELOPMENT
    ? REACT_APP_REVENUECAT_BILLING_SANDBOX_API_KEY
    : REACT_APP_REVENUECAT_BILLING_PUBLIC_API_KEY;

// purchases-js 0.15 builds a new instance on every configure call, so reuse the one already set up for this user.
export const configurePurchases = (appUserId) => {
  const isConfiguredForUser = Purchases.isConfigured() && Purchases.getSharedInstance().getAppUserId() === appUserId;
  if (!isConfiguredForUser) {
    Purchases.configure(getRevenueCatApiKey(), appUserId);
  }
  return Purchases.getSharedInstance();
};
